import React, { useState } from 'react'
import { useEffect } from 'react'
import { useAppSelector } from '../../app/hooks'
import Loader from '../../components/Preloader'
import { message } from 'antd';
import { NoticeType } from 'antd/es/message/interface'
import { LogoutIcon } from '../../icons';
import { useLogout } from '../../hooks/useLogout';
import useTheme from '../../hooks/useAppColor'; 
import styles from "../Profile/profile.module.scss"

export const LoadingPage = () => {

const res_error = useAppSelector(state => state.profile.profile_error)

const [messageApi, contextHolder] = message.useMessage();
const [isError, setIsError] = useState<boolean>(false)
const getTheme = useTheme()
const handleLogout = useLogout()

const showMessage = (type: NoticeType, content: string) => {
    messageApi.open({
      type: type,
      content: <div style={{ whiteSpace: 'normal', direction: 'ltr' }}>{content}</div>,
      duration: 15
    });
  };

useEffect(()  => {
    if(res_error.payload){
      setIsError(true)
      showMessage("error", `При запросе произошла ошибка: ${res_error.payload.error}. Аргументы запроса: ${JSON.stringify(res_error.meta.arg, null, 2)}`)
    }
}, [res_error])

useEffect(()  => {
  if(res_error.payload){
    setIsError(true)
    showMessage("error", `При запросе произошла ошибка: ${res_error.payload.error}. Аргументы запроса: ${JSON.stringify(res_error.meta.arg, null, 2)}`)
  }
}, [res_error])

  return (
    <div className={`f-c-col h-100v w-100v`}>
        {contextHolder}
        <Loader width={30} height={30}/>
        
        {isError && <div onClick={handleLogout} className={`big-btn whiteBorderedBlock ${getTheme("", "app-bg-dark")} f-column-betw al-center gap-15 w-100p ${styles.profileBtn}`}>
                        <LogoutIcon />
                        <div className="f-column f-1">
                            <p className='c-error txt-center fw-6 fz-m'>Выйти из <br /> аккаунта</p>
                        </div>
                    </div>}
    </div>
  )
}
